<template>
  <section aria-labelledby="payment-heading">
    <form method="POST" :action="paymentRoute" id="payment-method-form">
      <input type="hidden" name="token" id="token" :value="token">
      <input v-if="returnRoute" type="hidden" name="return_route" id="return_route" :value="returnRoute">
      <div class="w-full mb-4 md:grid md:grid-cols-4 md:gap-6">
          <div class="md:col-span-2">
              <label for="card-holder-name" class="block text-sm font-medium text-gray-700">Name on card</label>
              <input type="text" name="name" :value="user.name" id="card-holder-name"
              class="tw-input">
          </div>
      </div>

      <div class="mt-6 md:grid md:grid-cols-4 md:gap-6">
          <div class="md:col-span-4 lg:col-span-3">
              <div id="card-element" class="tw-input-parent"></div>
          </div>
          <div class="col-span-1">
              <button type="submit" :data-secret="intent.client_secret" id="card-button"
                  class="inline-flex items-center tw-button-green">
                  <svg id="card-button-icon" class="hidden w-5 h-5 mr-3 -ml-1 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                      </path>
                  </svg>
                  Update
              </button>
          </div>
          <div class="hidden mt-2 text-sm text-red-600" id="card-errors" role="alert"></div>
      </div>
    </form> 
  </section>
</template>
<script>
export default {
  props: {
    user: {
      type: [Object, Array],
      required: true,
    },
    intent: {
        type: [Object, Array],
        required: true,
    },
    token: {
      type: String,
      required: true,
    },
    returnRoute: {
      type: String,
      required: false,
    }
  },

  data() {
    return {
      paymentRoute: this.route('billing.update_payment_method'),
    };
  }
}
</script>
